/* eslint-disable max-statements */
/* eslint-disable complexity */
import type React from 'react';
import { useCallback, useContext } from 'react';
import { DSTabsContext, DSTabsCrossRefContext } from '../../DSTabsCTX.js';

interface UseKeyboardNavigationReturnTypeT {
  handleOnKeyDown: (e: React.KeyboardEvent) => void;
}

export const useKeyboardNavigation = (): UseKeyboardNavigationReturnTypeT => {
  const { focusableTabsRef } = useContext(DSTabsContext);
  const { firstSubtabInternalRef, lastTabInternalRef } = useContext(DSTabsCrossRefContext);

  const handleOnKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'ArrowRight' && focusableTabsRef.current) {
        e.preventDefault();
        e.stopPropagation();
        const nextTab =
          focusableTabsRef.current[(focusableTabsRef?.current?.indexOf?.(e.target as HTMLButtonElement) ?? 0) + 1];
        if (nextTab) nextTab.focus();
        if (!nextTab) return;
      }

      if (e.key === 'ArrowLeft' && focusableTabsRef.current) {
        e.preventDefault();
        e.stopPropagation();
        const prevTab =
          focusableTabsRef.current[(focusableTabsRef?.current?.indexOf?.(e.target as HTMLButtonElement) ?? 0) - 1];
        if (prevTab) prevTab.focus();
        if (!prevTab) return;
      }

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        e.stopPropagation();
        const canFocusCrossTabs = firstSubtabInternalRef?.current && lastTabInternalRef?.current;
        if (canFocusCrossTabs) firstSubtabInternalRef.current?.focus();
      }

      if (e.key === 'ArrowUp') {
        e.preventDefault();
        e.stopPropagation();
        const canFocusCrossTabs = firstSubtabInternalRef?.current && lastTabInternalRef?.current;
        if (canFocusCrossTabs) lastTabInternalRef.current?.focus();
      }
    },
    [firstSubtabInternalRef, lastTabInternalRef, focusableTabsRef],
  );

  return {
    handleOnKeyDown,
  };
};
